import { Projects } from "constantes/global";
import secureStorage from "hooks/secureStorage";
import { BASE_URL_PAMOFOR, BASE_URL_PRESFOR, COMMON_URL_PAMOFOR, COMMON_URL_PRESFOR } from "service/api";

// Handles smooth scrolling to a section with offset
export const handleSectionNavigation = (id) => {
  const element = document.getElementById(id);
  if (!element) return;
  
  const offset = 45;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};

export const openFileInNewTab = (base64String, mimeType) => {
  if (!base64String) return;

  try {
    // ✅ Supprimer le prefixe "data:...;base64," s'il existe
    const base64Data = base64String.split(',')[1] || base64String;

    // ✅ Convertir en tableau d’octets
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // ✅ Créer un Blob
    const blob = new Blob([byteArray], { type: mimeType });

    // ✅ Créer une URL temporaire
    const blobUrl = URL.createObjectURL(blob);

    // ✅ Ouvrir dans un nouvel onglet
    const newWindow = window.open(blobUrl, "_blank");

    // ✅ Libérer l’URL après quelques secondes
    setTimeout(() => URL.revokeObjectURL(blobUrl), 30000);

    if (!newWindow) {
      alert("Veuillez autoriser les pop-ups pour voir le fichier.");
    }
  } catch (error) {
    console.error("Erreur lors de l'ouverture du fichier :", error);
  }
};

// Constructs full file path based on environment
export const getFileFullPath = (path) => {
  let currentProject = "";
  if (!path) {
    console.error("Error: path is undefined or empty");
    return "";
  }



  const detectBaseUrl = (currentProject) => {

     currentProject = secureStorage.getItem("currentProject");
      

    if (currentProject = Projects[1].label) {
      return BASE_URL_PAMOFOR;
    }

    if (currentProject = Projects[2].label) {
      return BASE_URL_PRESFOR;
    }
    // console.log("detectBaseUrl", detectBaseUrl)

    console.error("Erreur : environnement inconnu, aucun baseUrl applicable.");
    return '';
  };

  const BASE_URL = detectBaseUrl(currentProject);
  if (!BASE_URL) {
    return '';
  }

  // console.log("BASE_URL", BASE_URL)

  const baseUrl = `${BASE_URL}/upload/enquete`;
  const filePath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${filePath}`;
};

export const activeLivrableButtonAfor = (livrableid, livrableVisibilityData) => {
  console.log("livrableVisibilityData", livrableVisibilityData);
  if (livrableid === 1) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'DCF')?.can_be_edited;
  } else if (livrableid === 4 || livrableid === 4.1) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'PVCL')?.can_be_edited;
  } 
  else if (livrableid === 8) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'ANP')?.can_be_edited;
  } else if (livrableid === 20) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'ANPO')?.can_be_edited;
  }
  else if (livrableid === 9) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'ANPC')?.can_be_edited;
  } else if (livrableid === 3 || livrableid === 30 || livrableid === 31 || livrableid === 32 || livrableid === 33 || livrableid === 34 || livrableid === 35 || livrableid === 36 || livrableid === 37 || livrableid === 38 || livrableid === 39 || livrableid === 40) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'PVRDC')?.can_be_edited;
  } else if (livrableid === 12) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'CLP')?.can_be_edited;
  } else if (livrableid === 19) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'CF')?.can_be_edited;
  } else if (livrableid === 11) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'VALID')?.can_be_edited;
  }
  else if (livrableid === 10) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'CECPDC')?.can_be_edited;
  } else if (livrableid === 13) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'PLAN_DEFINITIF')?.can_be_edited;
  } else if (livrableid === 5) {
    return livrableVisibilityData?.find(livrable => livrable?.type_livrable === 'PLAN_PROVISOIRE')?.can_be_edited;
  }
};
